import React from 'react';
import Reveal from './Reveal';

const SectionHead = ({ eyebrow, title, subtitle, center = false }) => (
  <Reveal className={`section-head ${center ? 'center' : ''}`}>
    {eyebrow && <span className="eyebrow">{eyebrow}</span>}
    <h2 className="section-title">{title}</h2>
    {subtitle && <p className="section-subtitle">{subtitle}</p>}
  </Reveal>
);

export default SectionHead;
